import { gql } from '@apollo/client';

export const FILTERED_SITES = gql`
  query FIlteredSites($input: SitesInput!) {
    sites: filteredSites(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
          startDate
          endDate
          status
          hierarchyLevelSubtype
          hierarchyLevel {
            id
            value
            typeOfSite
            hasSubtypes
            subtypes
          }
          parentSite {
            id
            name
          }
          hierarchy {
            id
            name
          }
          services {
            id
            name
          }
          organisation {
            id
            isInstitution
            isServiceProvider
            isFunder
            funder {
              id
              name
            }
            serviceProvider {
              id
              name
            }
            institution {
              id
              name
            }
          }
        }
      }
    }
  }
`;
